// extracted by mini-css-extract-plugin
module.exports = {"accordionExtender":"SupportAccordion_accordionExtender__KdqQX","container":"SupportAccordion_container__1WzHT","subContainer":"SupportAccordion_subContainer__8p_cp"};